import BtxSwitch from '../Forms/BtxSwitch';
import FieldTitle from './FieldTitle';
import NullableField from './NullableField';
import classNames from 'classnames';
import { Button, ModalBody, ModalFooter, Row, Col, Modal } from 'reactstrap';
import { Field, Form } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { actions } from '../../context';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const ConfigurationForm = (props) => {
    const {
        cancelEditing,
        closeEditing,
        data,
        practiceId: configPracticeId,
    } = props;
    const dispatch = useDispatch();
    const [pims, setPims] = useState([]);
    const { permissions } = useSelector((state) => ({
        permissions: state.auth.permissions,
    }));
    const pagePracticeId = useSelector((state) => state.practice.practice?.id);

    const hasPermission = (value) => permissions.indexOf(value) > -1;

    const [ignoreStatus, setIgnoreStatus] = useState(false);
    const [pristineOverride, setPristineOverride] = useState(true);
    const [otherPimName, setOtherPimName] = useState(false);
    let otherPimIds = [];

    useEffect(() => {
        setIgnoreStatus(data.ignoreStatus || false);
        dispatch(actions.pims.getAllPims()).then((res) => setPims(res.data));
    }, [dispatch, data]);

    const closeForm = (form) => {
        form.reset();
        cancelEditing();
    };

    const closeError = () => {
        cancelEditing();
        dispatch(actions.toggle.toggleConnectConfigModal(false));
    };

    const saveConfiguration = async (values) => {
        const settings = {
            ...values,
            pimsDbName: values?.pimsDbName || '',
            ignoreStatus: ignoreStatus,
        };
        //save
        dispatch(
            actions.practice.savePracticeConfiguration(
                configPracticeId,
                settings
            )
        ).then(() => {
            closeEditing(); //close editor
            dispatch(actions.toggle.triggerRefresh()); //refresh list
            dispatch(actions.toggle.triggerPracticeRefresh());
            dispatch(actions.toggle.activitiesRefresh());
        });
    };

    const formColClass = classNames('px-2 py-1');
    const lgColSize = 6;
    const mdColSize = 12;

    const havePimsWithId = (id) =>
        id && (pims || []).filter((x) => x.id === id).length > 0;
    const getPimsWIthId = (id) =>
        havePimsWithId(id) ? (pims || []).filter((x) => x.id === id)[0] : null;

    const showSettingForPims = (values, settingName) =>
        values?.pimsId &&
        havePimsWithId(values.pimsId) &&
        getPimsWIthId(values.pimsId).configurationKeys.includes(settingName);

    const getForm = () => {
        return (
            <Form
                initialValues={{ ...data }}
                onSubmit={saveConfiguration}
                render={({
                    handleSubmit,
                    form,
                    submitting,
                    pristine,
                    values,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <ModalBody>
                            <Row className="mx-2 d-flex justify-content-center text-light">
                                <Col
                                    lg={lgColSize}
                                    md={mdColSize}
                                    className={formColClass}>
                                    <FieldTitle title="Pims" />
                                    <Field
                                        name="pimsId"
                                        component="select"
                                        className="w-100 rounded p-2"
                                        label="PIMS"
                                        disabled={!hasPermission('EditPracticesPIMS', permissions)}>
                                        <option value="" selected disabled>
                                            Pims
                                        </option>
                                        <option />
                                        <optgroup label="Integration Supported">
                                            {(pims || [])
                                                .filter(
                                                    (p) =>
                                                        p.supportsConnectivity
                                                )
                                                .map((p, x) => (
                                                    <option
                                                        key={x}
                                                        value={p.id}>
                                                        {p.name}
                                                    </option>
                                                ))}
                                        </optgroup>
                                        <optgroup label="Manually Supported">
                                            {(pims || [])
                                                .filter(
                                                    (p) =>
                                                        !p.supportsConnectivity &&
                                                        p.name !== `Other`
                                                )
                                                .map((p, x) => (
                                                    <option
                                                        key={x}
                                                        value={p.id}>
                                                        {p.name}
                                                    </option>
                                                ))}
                                        </optgroup>
                                        <optgroup label="Not Listed">
                                            {(pims || [])
                                                .filter(
                                                    (p) =>
                                                        !p.supportsConnectivity &&
                                                        p.name === `Other`
                                                )
                                                .map((p, x) => {
                                                    otherPimIds.push(p.id);
                                                    return (
                                                        <option
                                                            key={x}
                                                            value={p.id}>
                                                            {p.name} (Specify)
                                                        </option>
                                                    );
                                                })}
                                        </optgroup>
                                    </Field>
                                    <OnChange name="pimsId">
                                        {(value) => {
                                            if (otherPimIds.includes(value)) {
                                                setOtherPimName(true);
                                            } else {
                                                setOtherPimName(false);
                                            }
                                        }}
                                    </OnChange>
                                </Col>
                                {(otherPimName ||
                                    otherPimIds.includes(values.pimsId)) && (
                                    <Col
                                        lg={lgColSize}
                                        md={mdColSize}
                                        className={classNames(formColClass)}>
                                        <FieldTitle title="Other Pims Name" />
                                        <Field
                                            className="w-100 p-2 rounded border"
                                            component="input"
                                            name="pimsOtherName"
                                            placeholder="Pims Name"
                                        />
                                    </Col>
                                )}
                                {hasPermission(`ManageIgnoreStatus`) && (
                                    <Col
                                        lg={lgColSize}
                                        md={mdColSize}
                                        className={classNames(formColClass)}>
                                        <FieldTitle title="Ignore status (for manual conversion)" />
                                        <BtxSwitch
                                            value={ignoreStatus || false}
                                            onChange={() => {
                                                setIgnoreStatus(!ignoreStatus);
                                                setPristineOverride(false);
                                            }}
                                            disabled={
                                                !hasPermission(
                                                    `ViewAllPractices`
                                                )
                                            }
                                        />
                                    </Col>
                                )}
                                <Col
                                    lg={lgColSize}
                                    md={mdColSize}
                                    className={classNames(formColClass, {
                                        'd-none': !showSettingForPims(
                                            values,
                                            'pms_directory'
                                        ),
                                    })}>
                                    <FieldTitle title="Pims Installation Directory" />
                                    <Field
                                        className="w-100 p-2 rounded border"
                                        component="input"
                                        name="pmsDirectory"
                                        placeholder="Directory"
                                    />
                                </Col>
                                <Col
                                    lg={lgColSize}
                                    md={mdColSize}
                                    className={classNames(formColClass, {
                                        'd-none': !showSettingForPims(
                                            values,
                                            'practice_host'
                                        ),
                                    })}>
                                    <FieldTitle title="Server Host Address" />
                                    <Field
                                        className="w-100 p-2 rounded border"
                                        component="input"
                                        name="practiceHost"
                                        placeholder="Address"
                                    />
                                </Col>
                                <Col
                                    lg={lgColSize}
                                    md={mdColSize}
                                    className={classNames(formColClass, {
                                        'd-none': !showSettingForPims(
                                            values,
                                            'pms_server'
                                        ),
                                    })}>
                                    <FieldTitle title="PIMS Server Name" />
                                    <Field
                                        className="w-100 p-2 rounded border"
                                        component="input"
                                        name="pmsServer"
                                        placeholder="Server"
                                    />
                                </Col>
                                <Col
                                    lg={lgColSize}
                                    md={mdColSize}
                                    className={classNames(formColClass, {
                                        'd-none': !showSettingForPims(
                                            values,
                                            'pms_dbname'
                                        ),
                                    })}>
                                    <FieldTitle title="Pims Database Name" />
                                    <Field
                                        className="w-100 p-2 rounded border"
                                        component="input"
                                        name="pmsDbName"
                                        placeholder="Database"
                                    />
                                </Col>
                                <Col
                                    lg={lgColSize}
                                    md={mdColSize}
                                    className={classNames(formColClass, {
                                        'd-none': !showSettingForPims(
                                            values,
                                            'pms_user'
                                        ),
                                    })}>
                                    <FieldTitle title="Pims Username" />
                                    <Field
                                        className="w-100 p-2 rounded border"
                                        component="input"
                                        name="pmsUser"
                                        placeholder="Username"
                                    />
                                </Col>
                                <Col
                                    lg={lgColSize}
                                    md={mdColSize}
                                    className={classNames(formColClass, {
                                        'd-none': !showSettingForPims(
                                            values, 
                                            'pms_password'
                                        ),
                                    })}>
                                    <FieldTitle title="Pims Password" />
                                    <NullableField
                                        className="w-100 p-2 rounded border"
                                        component="input"
                                        name="pmsPassword"
                                        placeholder="Empty Password"
                                        nullPlaceholder="NULL Password"
                                    />
                                </Col>
                                <Col
                                    lg={lgColSize}
                                    md={mdColSize}
                                    className={classNames(formColClass, {
                                        'd-none': !showSettingForPims(
                                            values,
                                            'odbc_version'
                                        ),
                                    })}>
                                    <FieldTitle title="ODBC Version" />
                                    <Field
                                        className="w-100 p-2 rounded border"
                                        component="input"
                                        name="odbcVersion"
                                        placeholder="Version"
                                    />
                                </Col>
                                {data.insideDeskConnected && (
                                    <Col
                                        lg={lgColSize}
                                        md={mdColSize}
                                        className={classNames(formColClass, {
                                            'd-none': !hasPermission(
                                                `InsideDeskManageApiKey`
                                            ),
                                        })}>
                                        <FieldTitle title="InsideDesk Api Key" />
                                        <Field
                                            name="insideDeskApiKey"
                                            component="input"
                                            className="w-100 p-2 rounded border"
                                            placeholder="Key"
                                        />
                                    </Col>
                                )}
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="danger"
                                onClick={() => closeForm(form)}>
                                Cancel
                            </Button>
                            <Button
                                color="primary"
                                type="submit"
                                disabled={
                                    (pristine && pristineOverride) ||
                                    submitting ||
                                    pagePracticeId !== configPracticeId //trying to track down the bug where the wrong practice is being updated (bug ticket #13144)
                                }>
                                {submitting
                                    ? 'Saving...'
                                    : pagePracticeId !== configPracticeId
                                    ? 'Unable to update configs'
                                    : 'Save'}
                            </Button>
                        </ModalFooter>
                    </form>
                )}></Form>
        );
    };

    const getMismatchView = () => {
        return (
            <>
                <ModalBody>
                    <h4 className="text-center text-light">
                        Error loading practice Configurations
                    </h4>
                    <p className="text-center text-light">
                        An error occurred while loading the configurations for
                        this practice. Please close and reopen this modal to
                        edit the practice configurations. If the problem
                        persists, please contact Bitwerx Operations
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={() => closeError()}>
                        Close
                    </Button>
                </ModalFooter>
            </>
        );
    };
    return pagePracticeId === configPracticeId ? getForm() : getMismatchView();
};

export default ConfigurationForm;
